interface ProposalProductForSaveState {
    isActive?: boolean
    multiplier?: number | string | null
}

interface SaveButtonStateInput {
    loading: boolean
    disabled: boolean
    products?: ProposalProductForSaveState[]
}

export const hasMultiplierError = (
    products: ProposalProductForSaveState[] = []
) => {
    return products.some(
        (product) => product?.isActive && Number(product?.multiplier) < 1
    )
}

export const shouldDisableSaveProposalButton = ({
    loading,
    disabled,
    products = []
}: SaveButtonStateInput) => {
    return loading || disabled || hasMultiplierError(products)
}